import { render, staticRenderFns } from "./PushTrigger.vue?vue&type=template&id=07154784&scoped=true"
import script from "./PushTrigger.vue?vue&type=script&lang=js"
export * from "./PushTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07154784",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07154784')) {
      api.createRecord('07154784', component.options)
    } else {
      api.reload('07154784', component.options)
    }
    module.hot.accept("./PushTrigger.vue?vue&type=template&id=07154784&scoped=true", function () {
      api.rerender('07154784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PushTrigger.vue"
export default component.exports